import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import comdetailsdata from '../data/comdetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import config from '../appconfig/config.json';

const PropertyAddress = (props) => { 
    const {addType, response} = props
   
    return(
        <div>
            {/* <Field component={CusFormLabel} 
                leftLabelId={'lblCountry'} leftLabelName={comdetailsdata.label.Country}
                id={'country'} name={'SINGAPORE'}/> */}
      
            {addType === config.addTypeLocal &&
            <div>
              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                    id={'blk'} name={response.PropertyDetails.Block_Number !== null? response.PropertyDetails.Block_Number:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.PropertyDetails.Street_Name !==null? response.PropertyDetails.Street_Name:''} />
                             
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.FlrNum} 
                    id={'lvl'} name={response.PropertyDetails.Storey_Number !==null? response.PropertyDetails.Storey_Number:''}  />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.PropertyDetails.Unit_Number !==null? response.PropertyDetails.Unit_Number:''}  />
                               
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.PropertyDetails.Building_Name !==null? response.PropertyDetails.Building_Name:''}  />

       
            </div>}

            {addType === config.addTypeLockedBag &&
            <div>
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPOName'} leftLabelName={comdetailsdata.label.PostOffice} 
                    id={'postoffName'} name={response.PropertyDetails.Post_Office_Name !== null? response.PropertyDetails.Post_Office_Name:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLockBagNo'} leftLabelName={comdetailsdata.label.LockedBagNo}
                    id={'lockbagno'} name={response.PropertyDetails.Locked_Bag_Number !==null? response.PropertyDetails.Locked_Bag_Number:''} />
                 
    
            </div>}

            {addType === config.addTypeGodown &&
            <div>

              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.PropertyDetails.Building_Name !==null? response.PropertyDetails.Building_Name:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblStoreyName'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'storeyName'} name={response.PropertyDetails.Storey_Number !==null? response.PropertyDetails.Storey_Number:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.PropertyDetails.Unit_Number !==null? response.PropertyDetails.Unit_Number:''}  />
                 
              <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.PropertyDetails.Street_Name !==null? response.PropertyDetails.Street_Name:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblGdNo'} leftLabelName={comdetailsdata.label.GodownNo}
                    id={'gdno'} name={response.PropertyDetails.Godown_Number !==null? response.PropertyDetails.Godown_Number:''} />


            </div>}

            {addType === config.addTypeMultiStorery &&
            <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                    id={'blk'} name={response.PropertyDetails.Block_Number !== null? response.PropertyDetails.Block_Number:''} />

                <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.PropertyDetails.Building_Name !==null? response.PropertyDetails.Building_Name:''}  />
                             
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.StoreyNo} 
                    id={'lvl'} name={response.PropertyDetails.Storey_Number !==null? response.PropertyDetails.Storey_Number:''}  />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.PropertyDetails.Unit_Number !==null? response.PropertyDetails.Unit_Number:''}  />
                 
                 <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.PropertyDetails.Street_Name !==null? response.PropertyDetails.Street_Name:''} />

            
            </div>}

            {addType === config.addTypeLotMukim &&
            <div>
              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.PropertyDetails.Street_Name !==null? response.PropertyDetails.Street_Name:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLotMukim'} leftLabelName={comdetailsdata.label.LotMukimNo}
                    id={'lotMukim'} name={response.PropertyDetails.Lot_Mukim_Number !==null? response.PropertyDetails.Lot_Mukim_Number:''} />
 

           
            </div>}

            {addType === config.addTypePObox &&
            <div>
            <Field component={CusFormLabel} 
                leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

            <Field component={CusFormLabel} 
                    leftLabelId={'lblBoxNo'} leftLabelName={comdetailsdata.label.BoxNo}
                    id={'boxno'} name={response.PropertyDetails.Box_Number !==null? response.PropertyDetails.Box_Number:''} />

            <Field component={CusFormLabel} 
                    leftLabelId={'lblPostOffice'} leftLabelName={comdetailsdata.label.PostOffice}
                    id={'postoffice'} name={response.PropertyDetails.Post_Office_Name !==null? response.PropertyDetails.Post_Office_Name:''} />

            </div>}

            {addType === config.addTypeHouseShopWalkupApmt &&
            <div>

              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.PropertyDetails.Building_Name !==null? response.PropertyDetails.Building_Name:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblHouseNo'} leftLabelName={comdetailsdata.label.HouseNo} 
                    id={'hno'} name={response.PropertyDetails.House_Number !==null? response.PropertyDetails.House_Number:''}  />
                 
                <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.PropertyDetails.Street_Name !==null? response.PropertyDetails.Street_Name:''} />
 
            </div>}

            {addType === config.addTypeWindowDeli &&
            <div>
              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.PropertyDetails.Postal_Code !==null? response.PropertyDetails.Postal_Code:''} />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblWindelino'} leftLabelName={comdetailsdata.label.WinDeliNo} 
                    id={'wdlino'} name={response.PropertyDetails.Window_Delivery_Number !==null? response.PropertyDetails.Window_Delivery_Number:''}  />

              <Field component={CusFormLabel} 
                    leftLabelId={'lblPostOffice'} leftLabelName={comdetailsdata.label.PostOffice} 
                    id={'postoffice'} name={response.PropertyDetails.Post_Office_Name !==null? response.PropertyDetails.Post_Office_Name:''}  />
                 
         
 
            </div>}
        </div>
    )
}

export default PropertyAddress